import React, { useState } from "react";
import './NotifContext.css'

interface INotif {
    start:boolean
}

interface IProps {
    type: string,
    msg: string,
    start?: boolean
}

type INotifProv = {
    Notif?: INotif,
    setNotif?: React.Dispatch<React.SetStateAction<INotif>>,
    run: (props:IProps)=>void
}

export const NotifContext = React.createContext<INotifProv | null>(null);

interface IChild {
    children: JSX.Element
}


export const NotifProvider = ({ children }: IChild) => {

    const [Notif, setNotif] = useState({start:false, type: "", msg: ""});


    
    const run = (props:IProps) => {
        const type = props.type
        const msg = props.msg
        setNotif({type, msg, start:true})
        setTimeout(() => {
            setNotif({type, msg, start:false})
        }, 2000)
    }

    return (
    <NotifContext.Provider value={{run}}>
        <div id="NotifMainDiv" className={`NotifMainDiv ${Notif.start ? "open" : ""}`}>
        <div className={`NotifMsg ${Notif.type}`}>{Notif.msg}</div>
        </div>
        {children}
    </NotifContext.Provider>
  );
};